import { render, staticRenderFns } from "./VerContratoProveedorModal.vue?vue&type=template&id=663d3525&"
import script from "./VerContratoProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./VerContratoProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('663d3525', component.options)
    } else {
      api.reload('663d3525', component.options)
    }
    module.hot.accept("./VerContratoProveedorModal.vue?vue&type=template&id=663d3525&", function () {
      api.rerender('663d3525', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/VerContratoProveedorModal.vue"
export default component.exports